import { Control } from 'react-hook-form';
import { Grid, Typography, Box, FormSwitch } from '../../../../base';
import { useTranslation } from 'react-i18next';
import { StyledNotificationTitle } from './NotificationRow.styles';
import { INotificationSetting } from '../../../../common';

interface NotificationRowProps {
    notification: INotificationSetting;
    control: Control<any>;
}

const NotificationRow = (props: NotificationRowProps) => {
    const { notification, control } = props;
    const { key, title, description } = notification;
    const { t } = useTranslation();

    return (
        <Grid container spacing={2} alignItems="center" sx={{ py: 2 }}>
            <Grid item xs={6}>
                <Box>
                    <StyledNotificationTitle variant="body2">
                        {t(title)}
                    </StyledNotificationTitle>
                    <Typography variant="body2" color="text.secondary">
                        {t(description)}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={3} display="flex" justifyContent="center">
                <FormSwitch
                    name={`notificationsSettings.${key}.sms`}
                    control={control}
                />
            </Grid>
            <Grid item xs={3} display="flex" justifyContent="center">
                <FormSwitch
                    name={`notificationsSettings.${key}.email`}
                    control={control}
                />
            </Grid>
        </Grid>
    );
};

export default NotificationRow;
